var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("HeaderLandingNew", {
        attrs: { "custom-class": "z-index-2", "is-dashboard": true }
      }),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "px-0 position-relative", attrs: { fluid: "" } },
        [
          _vm.isDefaultPage
            ? _c(
                "b-carousel",
                {
                  attrs: {
                    id: "carousel-1",
                    interval: 4000,
                    fade: "",
                    background: "#ababab",
                    "img-width": "100vw",
                    "img-height": "63%"
                  }
                },
                [
                  _c(
                    "b-carousel-slide",
                    { attrs: { "img-src": _vm.bgSubscribeSlider } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column w-51 ",
                          staticStyle: { "padding-bottom": "8%" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "slider-title text-left" },
                            [_vm._v("Partner with MusicVerse")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-left" }, [
                            _vm._v(
                              "Support Adventist musicians and global mission projects while listening to sacred music\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.currentRoute !== "TransactionSuccessPage"
                            ? _c("div", { staticClass: "d-flex" }, [
                                _vm.getUser.data.type === 0
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "learn-more ",
                                        attrs: {
                                          href: "/#/subscription",
                                          align: "left"
                                        }
                                      },
                                      [_vm._v("JOIN")]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "slider-image-subscribe" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/person-subscribe.png")
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-carousel-slide",
                    {
                      class: "carousel-donation-home",
                      attrs: { "img-src": _vm.bgDonationsSlider }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column w-51 ",
                          staticStyle: { "padding-bottom": "8%" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "slider-title text-left" },
                            [_vm._v("Missions")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "text-left",
                              staticStyle: { "margin-bottom": "4px" }
                            },
                            [_vm._v("Donate to MusicVerse to support missions")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-left" }, [
                            _vm._v(
                              "MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCreditPage
            ? _c(
                "div",
                { staticClass: "header-page w-100 position-relative" },
                [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.bgTopupSlider }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-title" }, [
                    _c("span", [_vm._v("Pay-as-you-go")])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSubscriptionPage
            ? _c(
                "div",
                { staticClass: "header-page w-100 position-relative" },
                [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.bgSubscribeSlider }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-title" }, [
                    _c("span", [_vm._v("Partner with MusicVerse")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("A portion of your payment will go to missions")
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isDonationsPage
            ? _c(
                "b-carousel",
                {
                  attrs: {
                    id: "carousel-mission",
                    interval: 4000,
                    fade: "",
                    background: "#ababab",
                    "img-width": "100vw",
                    "img-height": "63%"
                  }
                },
                [
                  _c(
                    "b-carousel-slide",
                    {
                      class: "carousel-donation-page",
                      attrs: { "img-src": _vm.bgDonationsSlider }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column w-51 ",
                          staticStyle: { "padding-bottom": "8%" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "slider-title text-left" },
                            [_vm._v("Missions")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "text-left",
                              staticStyle: { "margin-bottom": "4px" }
                            },
                            [_vm._v("Donate to MusicVerse to support missions")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-left" }, [
                            _vm._v(
                              "MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors"
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        {
          staticStyle: { "margin-top": "61px", "min-height": "45vh" },
          attrs: { fluid: "" }
        },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _vm.isMonthlySubscriber
        ? _c(
            "b-modal",
            {
              ref: "md-manage-subscription",
              attrs: {
                id: "md-manage-subscription",
                centered: "",
                "hide-footer": "",
                title: "Manage Subscription"
              },
              model: {
                value: _vm.toggleMM,
                callback: function($$v) {
                  _vm.toggleMM = $$v
                },
                expression: "toggleMM"
              }
            },
            [
              _c("p", { staticClass: "text-center" }, [_vm._v("Amount")]),
              _vm._v(" "),
              _vm.isChangeAmount
                ? [
                    _c("h2", { staticClass: "text-center" }, [
                      _vm._v(
                        "$" + _vm._s(_vm.userProfile.subscription.next_amount)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isMonthlySubscriber
                      ? _c("p", { staticClass: "text-warning text-center" }, [
                          _vm._v(
                            "\n        New amount will be charged on " +
                              _vm._s(
                                _vm.moment(
                                  _vm.userProfile.subscription
                                    .schedule_start_date
                                )
                              ) +
                              "\n      "
                          )
                        ])
                      : _vm._e()
                  ]
                : [
                    _c("h2", { staticClass: "text-center" }, [
                      _vm._v(
                        "$" +
                          _vm._s(_vm.userProfile.subscription.current_amount)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isMonthlySubscriber
                      ? _c("p", { staticClass: "text-warning text-center" }, [
                          _vm._v(
                            "\n        Auto Renewal on " +
                              _vm._s(
                                _vm.moment(
                                  _vm.userProfile.subscription.end_date
                                )
                              ) +
                              "\n      "
                          )
                        ])
                      : _vm._e()
                  ],
              _vm._v(" "),
              _vm.isMonthlySubscriber
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-4" },
                    [
                      _c(
                        "b-list-group",
                        { staticClass: "w-75" },
                        [
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex align-items-center cursor-pointer",
                              attrs: { disabled: _vm.isChangeAmount }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "d-flex justify-content-between w-100 text-dark",
                                  class: { "text-muted": _vm.isChangeAmount },
                                  on: { click: _vm.goToChangeAmount }
                                },
                                [
                                  _c("span", [_vm._v("Change Amount")]),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "chevron-right"] }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex align-items-center cursor-pointer"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "d-flex w-100 text-danger",
                                  on: { click: _vm.cancelSubscription }
                                },
                                [_vm._v("Cancel Subscription")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ba47ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba47ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = null
// module chunks = 